module.exports = __webpack_public_path__ + "img/training_mix7.4ec97d1c.jpg";